import { DataResultStyle } from '../../enums/google/data-result-style';
import { MajorDimension } from '../../enums/google/major-dimensions';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a GoogleSheetsQuery task.
 * Reads data from a Google Sheets spreadsheet using a Service Account.
 * One query is executed per input record; spreadSheetID and selectionFilter support expression syntax.
 */
export class GoogleSheetsQueryConfig extends DestinationTaskConfigBase {
	/** Google Service Account email. The spreadsheet must be shared with this account. @default '' */
	serviceAccountEmail = '';
	/** Google Service Account PEM private key (from the downloaded JSON key file). Resolved via GETSECRET() expression at runtime. @default '' */
	serviceAccountPrivateKey = '';
	/** Google Sheets spreadsheet ID (from the URL). Supports expression syntax per record. @default '' */
	spreadSheetID = '';
	/** A1 notation range specifying cells to read (e.g. 'Sheet1!A1:Z1000'). Supports expression syntax per record. @default '' */
	selectionFilter = '';
	/** Whether data is returned row-by-row or column-by-column. ROWS=0, COLUMNS=1. @default MajorDimension.ROWS */
	majorDimension: MajorDimension = MajorDimension.ROWS;
	/**
	 * Output format.
	 * RAW=0: one record per input record, processingData = { rows: [[v1, v2, ...], ...] }.
	 * RecordBased=1: one record per spreadsheet row, processingData = { value1, value2, ... }.
	 * @default DataResultStyle.RAW
	 */
	resultPayloadStyle: DataResultStyle = DataResultStyle.RAW;

	constructor(init?: Partial<GoogleSheetsQueryConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
